import * as t from "counterpart";
import api from "../../utilities/API";

//
export function loadFavorites()
{
	return function(dispatch, state)
	{
		if(state().commerce.favorites.isLoading) {
			return;
		}

		dispatch({type: "FAVOURITES_LOADING"});

		api("/commerce/wishlist/", {
			result: (data) => dispatch({type: "COMMERCE_SET_FAVORITES", payload: data || {}}),
			error: (error) => alert(t("Favorites")+": "+error) // dispatch({type: "COMMERCE_ERROR", payload: error}),
		})
	}
}

//
export function addToFavorites(product_id, after, remove)
{
	return function(dispatch)
	{
		let url = "commerce/wishlist/";
		if(remove) {
			url += product_id;
		}

		api(url, {
			method: remove ? "DELETE" : "POST",
			data: {product_id},
			result: () => {
				dispatch(loadFavorites());
				after(remove ? "removed" : "success");
			},
			error: (e) => {
				alert(e);
				after("error");
			},
		})
	}
}

//
export function addToCompare(data) {
	return function(dispatch) {
		dispatch({type: "COMMERCE_SET_COMPARE", payload: data})
	}
}
